<template>
  <div class="loginpage">
    <div class="loginBox">
      <div class="login-content">
        <div class="login-left">
          <div>
            <div
              class="title2"
              style="
                font-size: 38px;
                margin-top: 55px;
                text-align: center;
                padding-left: 0;
              "
            >
              {{ $store.state.eduWebConfig.eduWebConfigInfo.webName
              }}<br /><span style="font-size: 22px">{{
                $store.state.eduWebConfig.eduWebConfigInfo.orgName
              }}</span>
            </div>
            <img
              width="300px"
              style="margin-left: 83px"
              src="/static/images/ly_logo.png"
              alt=""
            />
          </div>
        </div>
        <div class="login-right">
          <div class="title3">用户登录 / Login</div>
          <div class="log-row">
            <div style="margin-bottom: 10px">
              <span class="title4">用户名</span>
              <span class="title5">/ Username</span>
            </div>
            <el-input
              class="input-style userName"
              v-model="userName"
              @on-enter="uiLogin"
              type="text"
              :value="userName"
              placeholder="请输入用户名"
            />
          </div>
          <div class="log-row">
            <div style="margin-bottom: 10px">
              <span class="title4">密码</span>
              <span class="title5">/ Password</span>
            </div>
            <el-input
              class="input-style userPwd"
              v-model="userPwd"
              @on-enter="uiLogin"
              type="password"
              :value="userPwd"
              placeholder="请输入密码"
            />
          </div>
          <div class="log-row">
            <el-button class="input-style btn" type="primary" @click="uiLogin"
              >登 录
            </el-button>
            <div
              style="
                margin-top: 20px;
                display: flex;
                justify-content: space-between;
              "
            >
              <!-- <span
                              class="forget_pwd"
                              @click="$router.push({ name: 'registeredNumber' })"
                              >人员注册</span
                            >-->
              <!-- <span
                                class="forget_pwd"
                                @click="$router.push({ name: 'answerRegister' })"
                            >校外人员答题</span
                            > -->
              <!-- <span class="forget_pwd" @click="backPwd">忘记密码？</span> -->
            </div>
            <!-- <div style="margin-top:5px">
                          <span
                            class="forget_pwd"
                            @click="$router.push({ name: 'answerRegister' })"
                            >校外人员答题</span
                          >
                        </div> -->
          </div>
        </div>
      </div>
      <div class="bottom-text">
        <p>
          <a target="_bank" href="http://www.beian.miit.gov.cn"
            >蜀ICP备20012822号-4</a
          >
        </p>
        <p >
          <a href="http://www.bluerhyme.net/" target="_bank"
            >四川蓝韵心理咨询服务有限公司</a
          >
        </p>
        <p>
          <a href="http://www.bluerhyme.net/" target="_bank"
            >四川心海蓝韵信息科技有限公司</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import screenfull from "screenfull"; //引入screenfull
export default {
  name: "login",
  data() {
    return {
      userName: "",
      userPwd: "",
      remenber: false,
    };
  },
  methods: {
    uiLogin() {
      var self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("用户登录错误！" + e.err);
          } else {
            if (e.rtnObj) {
              var result = e.rtnObj;
              if (result.success) {
                if (result.data != null) {
                  //设置token信息
                  self.$store.commit(
                    "SET_TOKEN",
                    result.data.TokenInfo.token_id
                  );
                  //跳转到主界面
                  self.$router.push("/home");
                  // self.toFullscreen();
                }
              } else {
                self.$message.error("用户登录失败，" + result.errmsg);
              }
            } else {
              self.$message.error("用户登录错误，数据结果有误！");
            }
          }
        },
        "SysMgrBiz.Login",
        this.userName,
        this.userPwd
      );
    },
    toFullscreen() {
      //不支持screenfull全屏，则打印错误
      if (!screenfull.isEnabled) {
        console.error("unEnabled");
        return;
      }
      screenfull.toggle();
    },
    // 忘记密码
    backPwd() {
      this.$router.push({
        name: "forgetPassword",
      });
    },
  },
};
</script>

<style scoped>
.loginpage {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: #eef3fa;
  height: 100%;
  width: 100%;
  z-index: 1000;
}

.loginBox {
  position: absolute;
  left: 50%;
  min-width: 1658px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  background-image: url("/static/images/登录背景1.png");
  background-size: cover;
}

.topImg img {
  width: 100%;
  height: 100%;
}

.login-content {
  width: 960px;
  height: 540px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  -webkit-border-radius: 5px;
  -ms-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  box-shadow: 0 0 20px rgba(12, 82, 126, 1);
}

.login-left {
  float: left;
  width: 49%;
  height: 100%;
  background-image: url("/static/images/登录背景2.png");
  border-radius: 5px 0 0 5px;
  /*padding: 10px;*/
}

.login-right {
  float: left;
  width: 44%;
  margin: 30px;
}

.title1 {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  font-size: 48px;
  color: #ffffff;
  padding: 30px 30px 0 30px;
  /*text-align: left;*/
}

.title2 {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
  padding-left: 55px;
}

.title3 {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  color: #01058a;
  font-size: 32px;
  padding: 25px 0 10px 10px;
}

.title4 {
  font-family: "微软雅黑 Bold", "微软雅黑";
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  color: #01058a;
}

.title5,
.forget_pwd {
  color: #918d9a;
  font-family: "Arial Normal", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  cursor: pointer;
}

.forget_pwd:hover {
  color: #01058a;
}

.log-row {
  padding: 30px 10px 10px 10px;
}

.log-row {
  width: 410px !important;
}

.input-style {
  width: 410px;
  border: none;
  /*height: 50px;*/
}

.btn {
  /*margin-top: 24px;*/
  font-weight: 700;
  font-size: 18px;
  height: 48px;
}

.bottom-text {
  width: 100%;
  position: absolute;
  bottom: 1%;
  text-align: center;
  font-size: 14px;
}

.bottom-text a {
  color: #ffffff;
  text-decoration: none;
}

/deep/ .el-input__inner {
  height: 48px;
  border: none;
  border-bottom: 1px solid #dcdfe6;
  border-radius: 0px;
}

/deep/ .el-radio__inner {
  width: 18px !important;
  height: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue